import { useCallback, useContext } from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadataInternal } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import messages from './VehicleDetailsComponent_AX.messages';
import metadata from './VehicleDetailsComponent_AX.metadata.json5';

function VehicleDetailsComponentAX(props) {
    const {
        vehicleDetails
    } = props;

    const translator = useContext(TranslatorContext);

    const overrideProps = {
        '@field': {
            labelPosition: 'top'
        },
    };

    const readValue = useCallback(
        (id, path) => {
            const value = _.get(vehicleDetails, path);

            if (value === 'null') {
                return '';
            }

            if (path === 'vehicleType') {
                return translator({
                    id: `typekey.VehicleType.${value}`,
                    defaultMessage: ''
                });
            }
            if (path === 'lossParty') {
                return translator({
                    id: `typekey.LossPartyType.${value}`,
                    defaultMessage: ''
                });
            }
            return value;
        }, [translator, vehicleDetails]
    );

    const resolvers = {
        resolveValue: readValue
    };

    return renderContentFromMetadataInternal(metadata.componentContent, overrideProps, resolvers);
}

VehicleDetailsComponentAX.propTypes = {
    vehicleDetails: PropTypes.object.isRequired,
};

export default withRouter(VehicleDetailsComponentAX);
